import styled from 'styled-components'

interface Props {
  gapSize?: string
}

export const Stack = styled.div<Props>`
  display: grid;
  gap: ${({ gapSize = '1.6rem' }) => gapSize};
  align-content: baseline;
`
